import PropTypes from 'prop-types'
import React from 'react'
import Button from './Button'
import ShowHide from './ShowHide'
import Space from './Space'
import { Display1 } from './typography'
import UpgradePromptTooltip from './UpgradePromptTooltip'
import './PlanCard.css'

const plans = {
  developer: {
    type: 'developer',
    name: 'Developer',
    featuresIntro: '',
    features: [
      'Unlimited Integrations',
      '1 Source',
      '1 Warehouse',
      '1 Warehouse Sync a day',
      <span>1 <UpgradePromptTooltip message='The number of people who have access to your Segment account.'>Seat</UpgradePromptTooltip></span>
    ],
    pricing: 'Free',
    pricingTagline: 'Limited to 1000 MTUs per month',
    cta: 'Upgrade to Developer'
  },
  team: {
    type: 'team',
    name: 'Team',
    featuresIntro: 'Current Plan Features, plus:',
    features: [
      'Unlimited Integrations',
      'Unlimited Sources',
      '2 Warehouse Syncs a day',
      <span>7 <UpgradePromptTooltip message='The number of people who have access to your Segment account.'>Seats</UpgradePromptTooltip></span>
    ],
    pricing: '$10/1000 MTUs',
    pricingTagline: 'Starting from $100 per month',
    cta: 'Start your 14 day trial'
  },
  business: {
    type: 'business',
    name: 'Business',
    featuresIntro: 'Team Plan Features, plus:',
    features: [
      'Unlimited Warehouses',
      'Unlimited Warehouse Syncs a day',
      <span>Unlimited <UpgradePromptTooltip message='The number of people who have access to your Segment account.'>Seats</UpgradePromptTooltip></span>,
      <UpgradePromptTooltip message='Schema filtering allows you to choose which pieces of data get sent into your data warehouse'>Schema Filtering</UpgradePromptTooltip>,
      <UpgradePromptTooltip message='Notifications when a user makes a change to your account or if there is an issue with your setup.'>Alerting</UpgradePromptTooltip>,
      <UpgradePromptTooltip message='Load all of your historical data into new integrations.'>Data Replay</UpgradePromptTooltip>,
      <span>Premium <UpgradePromptTooltip message='Dedicated Success Manager, Implementation Engineer, and Service Level Agreement.'>Dedicated</UpgradePromptTooltip> Support</span>
    ],
    pricing: 'Custom',
    pricingTagline: 'Volume discounts available',
    cta: 'Contact Us',
    ctaAddendum: 'Or call us at +1 (415) 649-6900',
    ctaHref: '/contact/sales'
  }
}

const PlanCard = props => {
  const { type, onCtaClick, loading, overrides } = props
  const plan = {
    ...plans[type],
    ...overrides
  }

  return (
    <div className={`PlanCard PlanCard--${type}`}>
      <div className='PlanCard-icon' />
      <div style={{ paddingLeft: 20, paddingRight: 20 }}>
        <Display1>{plan.name}</Display1>
        <Space value={18} />
        <div className='PlanCard-featuresIntro ui-Copy'>{plan.featuresIntro}</div>
        <ul>
          {plan.features.map((feature, index) => <li className='PlanCard-feature ui-Copy' key={`__plancard_feature_${index}`}>{feature}</li>)}
        </ul>
      </div>
      <div style={{ paddingLeft: 30, paddingRight: 30 }}>
        <h6 className='PlanCard-pricing'>{plan.pricing}</h6>
        <p className='PlanCard-pricingTagline ui-Copy tiny'>{plan.pricingTagline}</p>
        <Space value={14} />
        <Button
          extras='fluid rounded'
          loading={loading}
          onClick={() => {
            if (plan.ctaHref) window.open('/contact/sales')
            if (onCtaClick) onCtaClick(type)
          }}>{plan.cta}</Button>
        <ShowHide show={plan.ctaAddendum}>
          <p className='PlanCard-ctaAddendum ui-Copy tiny'>{plan.ctaAddendum}</p>
        </ShowHide>
      </div>
    </div>
  )
}

PlanCard.displayName = 'PlanCard'

PlanCard.propTypes = {
  type: PropTypes.string.isRequired,
  onCtaClick: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  overrides: PropTypes.object
}

export default PlanCard



// WEBPACK FOOTER //
// ./ui/PlanCard.js